import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/camera.svg'
import _imports_1 from '@/assets/img/logo/warning.svg'


const _withScopeId = n => (_pushScopeId("data-v-e8bf540c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-[768px] h-full min-h-screen bg-red-5" }
const _hoisted_3 = { class: "my-4 font-bold text-lg justify-between flex" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "w-full flex-wrap flex" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { for: "file" }
const _hoisted_8 = { class: "btn-upload mr-4 mb-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-6 h-6"
}, null, -1))
const _hoisted_10 = { class: "text-xs mt-1 text-[#898989]" }
const _hoisted_11 = {
  key: 0,
  class: "text-xs text-red-500 flex items-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "w-3 h-3 mr-1"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "개체 사진을 등록해주세요!", -1))
const _hoisted_14 = ["onDragstart", "onDrop"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-[2px]" }, "×", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border-solid border-b border-zinc-100 my-8" }, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "pl-24 text-xs text-red-500 flex items-center mb-4"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "w-3 h-3 mr-1"
}, null, -1))
const _hoisted_22 = {
  key: 1,
  class: "pl-20 text-xs text-red-500 flex items-center my-4"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "w-3 h-3 mr-1"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border-solid border-b border-zinc-100 my-8" }, null, -1))
const _hoisted_25 = { class: "flex flex-col space-y-4" }
const _hoisted_26 = { class: "flex items-center font-medium" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 text-lg" }, [
  /*#__PURE__*/_createTextVNode("가격"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-pada" }, "*")
], -1))
const _hoisted_28 = {
  key: 0,
  class: "pl-20 text-xs text-red-500 flex items-center my-4"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "w-3 h-3 mr-1"
}, null, -1))
const _hoisted_30 = { class: "flex items-center font-medium" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 text-lg" }, [
  /*#__PURE__*/_createTextVNode("제목"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-pada" }, "*")
], -1))
const _hoisted_32 = {
  key: 1,
  class: "pl-20 text-xs text-red-500 flex items-center my-4"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "w-3 h-3 mr-1"
}, null, -1))
const _hoisted_34 = { class: "flex items-start font-medium" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 mt-2 text-lg" }, [
  /*#__PURE__*/_createTextVNode("내용"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-pada" }, "*")
], -1))
const _hoisted_36 = {
  key: 2,
  class: "pl-20 text-xs text-red-500 flex items-center my-4"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "w-3 h-3 mr-1"
}, null, -1))
const _hoisted_38 = { class: "w-full flex justify-end mt-8" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-40" }, null, -1))
const _hoisted_40 = { key: 1 }

import { ref, reactive, computed, onMounted, isVNode } from 'vue';
import imageCompression from "browser-image-compression";
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { genderToText, formattedGender } from '@/utils/formattedUnit';
import { getUserId } from '@/utils/Functions';
import {  SearchApi } from '@/api/api';
import WriteCategory from './WriteCategory.vue';
import WriteAttribute from './WriteAttribute.vue';
import DimmedLoading from '../UI/DimmedLoading.vue';
import ConfirmModal from '../UI/ConfirmModal.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchWrite',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const editData = computed(() => store.state.clickedAdopt)
const isEditMode = computed(() => route.path.includes('/edit'))
const postId = route.params.encodedId;
const changedImgStatus = ref(false);
const userId = getUserId();
const testMsg = ref('');
const apiError = ref(false);
const writeLoading =ref(false);
const thumbnail = ref([ ]);
const draggedIndex = ref(null);
const initImg = ref([ ]);
const formData = reactive({
    user_id : null,
    jong: null,
    detail: [],
    gender: '',
    size: null,
    location: null,
    locationDetail: null,
    title: null,
    content: null,
    price: null,
    images :[],
    ztype :'',
});
const nullMsg = reactive({
    jong: '',
    gender: '',
    size: '',
    location: '',
    title: '',
    content: '',
    price: '',
    images : '',
})

const dragStart= (index) => {
    draggedIndex.value = index;
}
const drop = (index) => {
    const dragIndex = draggedIndex.value
    const draggedElement = thumbnail.value[dragIndex];
    thumbnail.value.splice(dragIndex, 1);
    thumbnail.value.splice(index, 0, draggedElement);

    // formData.images 배열의 요소도 동일하게 재정렬
    const draggedImage = formData.images[dragIndex];
    formData.images.splice(dragIndex, 1);
    formData.images.splice(index, 0, draggedImage);
}

// 이미지 압축하기 
const compressImage = async (file) => {
    const options = {
        maxSizeMB: 0.7,
        maxWidthOrHeight: 1200,
        useWebWorker: true,
    };
    return await imageCompression(file, options);
};
// 이미지 업로드 
const upload = async (e: Event) => {
    const input = e.target as HTMLInputElement;
    if (input.files) {
        const files = Array.from(input.files).slice(0, 10); // 최대 10개의 파일만 선택
        for (let file of files) {
            const url = URL.createObjectURL(file);
            thumbnail.value.push(url); // 미리보기용 URL 추가
            formData.images.push(file); // 실제 파일을 formData에 추가
        }
    }
};

const deletePhoto = (index) => {
    thumbnail.value = thumbnail.value.filter((_, idx) => idx !== index);
    formData.images = formData.images.filter((_, idx) => idx !== index);
};

// 등록 버튼
const submitData = async () => {
    if(!isEmpty()) {
        return;
    } 
    writeLoading.value = true;
    formData.location = formData.locationDetail ?  `${formData.location}/${formData.locationDetail}` : formData.location

    try {
        if(!isEditMode.value) {
            await submitIncludeImage(); // 처음 글 등록
            testMsg.value = '처음 올리는 게시글'
            // console.log('처음 올리는 게시글');
        } else if (checkChangeImg()) {
            await editChangedImg(); // 이미지와 같이 바꾸기
            testMsg.value = '이미지와 같이 바꾸기'
            // console.log('이미지와 같이 바꾸기')
        } else {
            await editOnlyText(); // 텍스트만 바꾸기
            testMsg.value = '텍스트만 바꾸기'
            // console.log('텍스트만 바꾸기')
        }

        await store.dispatch('resetReptileList');
        // console.log('success, reptile 이동')
        router.push('/reptile')

    } catch (error) {
        console.error('게시물 등록 중 오류 발생:', error);
        apiError.value = true;
    } finally {
        // 오류가 발생하든 말든, 항상 실행되는 부분
        writeLoading.value = false;
    }
};
const handleApiError = () =>{
    apiError.value = false;
    router.push('/reptile')
}

// 게시글 처음 등록 할 때!!!
const submitIncludeImage = async () => {
    const form = new FormData();
    // 기본 필드 추가
    form.append('jong', formData.jong);
    form.append('detail', formData.detail.join());
    form.append('ztype', formData.ztype);
    form.append('rsex', genderToText(formData.gender));
    form.append('size', formData.size);
    form.append('location',  formData.location);
    form.append('price', formData.price);
    form.append('title', formData.title);
    form.append('content', formData.content);
    form.append('user_id', userId);


    // 이미지 파일 추가
    for (const [index, image] of formData.images.entries()) {
        // 0번 인덱스 이미지 파일, 압축하고 썸네일로 복사하기
        const compressedFile = await compressImage(image);
        if(index === 0){
            try {
                // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`);
                form.append('uploadfiles', compressedFile, `${image.name}_thumbnail`);
            } catch (error) {
                console.log(error);
            }
        }
        form.append('uploadfiles', compressedFile, image.name);
    }

    // 서버에 FormData 전송
    try {
        const response = await SearchApi.addAdoptImages(form);
    } catch (error) {
        console.error(error);
    }
};

// // 게시글 only 텍스트
const editOnlyText = async () => {
    //서버에 FormData 전송
    try {
        const response = await SearchApi.editAdoptText(
            {
                post_id: postId,
                user_id: userId, 
                jong: formData.jong,
                detail: formData.detail.join(),
                rsex: genderToText(formData.gender), // 미구분 => 0으로 바뀜
                size: formData.size,
                location: formData.location,
                title: formData.title,
                content: formData.content,
                price: formData.price,
                ztype: formData.ztype,
            }
        );
    } catch (error) {
        console.log(error)
    }
};


const checkChangeImg =  () => {
    if(editData.value){
        const originCnt = editData.value.image_cnt - 1
        const changeCnt = formData.images.length // 2
        if(originCnt !== changeCnt) return changedImgStatus.value = true;
        
    }
    let originArr = [...initImg.value]
    let compareArr = [...formData.images];
    // for(let i = 1; i <= changeCnt ; i++){
    //     compareArr.push(formData.images[`imgURL${i}`])
    // }
    // console.log(originArr.toString())
    // console.log(compareArr.toString())
    if(originArr.toString() !== compareArr.toString()){
        return changedImgStatus.value = true;

    } else{
        return changedImgStatus.value = false;

    }
}

// url을 blob으로 바꾸기
async function urlToBlob(url) {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error('Network response was not ok.');
    }
    return await response.blob();
}

const editChangedImg = async () => {
    const form = new FormData();
    // 기본 필드 추가
    form.append('post_id', postId.toString())
    form.append('jong', formData.jong);
    form.append('detail', formData.detail.join());
    form.append('ztype', formData.ztype);
    form.append('rsex', genderToText(formData.gender));
    form.append('size', formData.size);
    form.append('location', formData.location);
    form.append('price', formData.price);
    form.append('title', formData.title);
    form.append('content', formData.content);
    form.append('user_id', userId);

    // 이미지 파일 추가
    for (const [index, image] of formData.images.entries()) {

        if (image instanceof File) {
            try {
                const compressedFile = await compressImage(image);
                // 첫 번째 이미지의 경우, 썸네일 버전 추가
                if (index === 0) {
                    form.append('uploadfiles', compressedFile, `${image.name}_thumbnail.jpg`);
                }
                // 모든 이미지 파일 추가
                form.append('uploadfiles', compressedFile, image.name);
            } catch (error) {
                console.log(error);
                // 사용자에게 오류 메시지 표시 (예: UI 알림)
            }
        } else if (typeof image === 'string') {
            try {
                const imageBlob = await urlToBlob(image);
                const imageName = image.split('/').pop();

                // 첫 번째 이미지의 경우, 썸네일 버전 추가
                if (index === 0) {
                    form.append('uploadfiles', imageBlob, `${imageName}_thumbnail.jpg`);
                }
                // URL에서 파일 이름 추출
                form.append('uploadfiles', imageBlob, imageName);
            } catch (error) {
                console.log(error);
                // 오류 처리
        }
    }
}

    // 서버에 FormData 전송
    try {
        const response = await SearchApi.editAdoptImages(form);
    } catch (error) {
        console.error(error);
    }

}


const isEmpty = () => {
    nullMsg.title = (!formData.title || formData.title.length < 4) ? '제목은 4글자 이상 입력해주세요.' : '';
    nullMsg.content = (!formData.content || formData.content.length < 4) ? '내용을 4글자 이상 입력해주세요.' : '';
    nullMsg.jong = formData.jong ? '' : '종을 선택해주세요.';
    nullMsg.gender = formData.gender ? '' : '성별';
    nullMsg.location = formData.location ? '' : '지역';
    // formData.jong이 특정 카테고리에 해당하는 경우 size의 empty 값을 무시
    if (formData.jong === '사육장' || formData.jong === '먹이' || formData.jong === '기타 용품' || formData.jong === '도서') {
    // 사이즈 필드 검사를 생략하거나 다른 로직 적용
        nullMsg.size = '';
    } else {
    // 그 외의 경우에는 사이즈가 비어있는지 확인
        nullMsg.size = formData.size ? '' : '사이즈';
    }
    // nullMsg.title = (formData.title ?? '').length > 4 ? '제목은 4글자 이상 입력해주세요.' : '';
    // nullMsg.content = formData.content ? '' : '내용을 입력해주세요.';
    nullMsg.price = formData.price && formData.price < 1000000000 ? '' : '가격을 입력해주세요';
    // formData.images.length !== 0 ?  '' : '이미지 오류';
    nullMsg.images = formData.images.length > 0 ? '' : '이미지를 최소 1개 이상 업로드해주세요.';
    // console.log(!Object.values(nullMsg).some(msg => msg !== ''))

    return !Object.values(nullMsg).some(msg => msg !== ''); // true 이면 모든 칸 다 차있음
}

// setFilter 함수를 사용하여 formData 객체 업데이트
const setFilter = (type: string, newValue: string | string[]) => {
    formData[type] = newValue;
    // console.log('setFilter : ',type, formData[type] )
};
onMounted(() => {
    // store.dispatch('viewAdopt', postId);
    // console.log('check', editData.value)
    if(isEditMode.value ){
    // if(isEditMode.value && checkUserId()){
        setFilter('gender', formattedGender(editData.value.rsex)); // 0 => 미구분, 1 => 수컷 
        setFilter('size', editData.value.size);
        formData.price = editData.value.price;
        formData.title = editData.value.title;
        formData.content = editData.value.content;

        let location;
        let locationDetail;

        if (editData.value.location.includes('/')) {
            const parts = editData.value.location.split('/');
            location = parts[0]; // '서울'
            locationDetail = parts[1]; // '강남'
            setFilter('location', location);
            setFilter('locationDetail', locationDetail)
        } else {
            location= editData.value.location
            setFilter('location', location);
            
        }
        
        
        for (let i = 1; i < editData.value.image_cnt; i++){
            formData.images.push(editData.value[`imgURL${i}`])
            thumbnail.value.push(editData.value[`imgURL${i}`])
            initImg.value.push(editData.value[`imgURL${i}`]);
        }

    }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (writeLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(DimmedLoading)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(isEditMode.value ? '분양글 수정' : '분양글 쓰기'), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("p", _hoisted_10, "(" + _toDisplayString(thumbnail.value.length) + "/10)", 1)
            ])
          ]),
          _createElementVNode("input", {
            type: "file",
            name: "file",
            id: "file",
            onChange: upload,
            multiple: "",
            accept: "image/*"
          }, null, 32),
          (thumbnail.value.length ===0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(),
                _hoisted_13
              ]))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thumbnail.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "previewImg relative mr-4 mb-4",
            draggable: "true",
            onDragstart: ($event: any) => (dragStart(index)),
            onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
            onDrop: ($event: any) => (drop(index))
          }, [
            _createElementVNode("img", {
              src: item,
              alt: "",
              class: "w-full h-full object-cover rounded-xl"
            }, null, 8, _hoisted_15),
            _createElementVNode("button", {
              class: "bg-[#17181a] w-6 h-6 rounded-full absolute -top-2 -right-2 flex justify-center items-center font-light cursor-pointer text-white",
              onClick: ($event: any) => (deletePhoto(index))
            }, _hoisted_18, 8, _hoisted_16)
          ], 40, _hoisted_14))
        }), 128))
      ]),
      _hoisted_19,
      _createVNode(WriteCategory, {
        "onUpdate:jong": _cache[1] || (_cache[1] = value => setFilter('jong', value)),
        "onUpdate:detail": _cache[2] || (_cache[2] = value => setFilter('detail', value))
      }),
      (nullMsg.jong)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(nullMsg.jong), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(WriteAttribute, {
        selectedSpecies: formData.jong,
        selectedGender: formData.gender,
        selectedSize: formData.size,
        selectedLocation: formData.location,
        selectedLocationDetail: formData.locationDetail,
        "onUpdate:gender": _cache[3] || (_cache[3] = value => setFilter('gender', value)),
        "onUpdate:size": _cache[4] || (_cache[4] = value => setFilter('size', value)),
        "onUpdate:location": _cache[5] || (_cache[5] = value => setFilter('location', value)),
        "onUpdate:locationDetail": _cache[6] || (_cache[6] = value => setFilter('locationDetail', value))
      }, null, 8, ["selectedSpecies", "selectedGender", "selectedSize", "selectedLocation", "selectedLocationDetail"]),
      (nullMsg.size || nullMsg.gender || nullMsg.location)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _hoisted_23,
            _createTextVNode(),
            _createElementVNode("span", null, _toDisplayString(nullMsg.size) + " " + _toDisplayString(nullMsg.gender) + " " + _toDisplayString(nullMsg.location) + "을(를) 선택해주세요. ", 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _withDirectives(_createElementVNode("input", {
            class: "w-1/2 h-10 pl-4 border border-solid text-sm font-normal border-[#D6D6D6] rounded-md placeholder:text-sm placeholder:text-zinc-300 placeholder:font-light focus:border-[#1B1B1D]",
            placeholder: "ex) 100000",
            type: "number",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.price) = $event))
          }, null, 512), [
            [_vModelText, formData.price]
          ])
        ]),
        (nullMsg.price)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createTextVNode(),
              _createElementVNode("span", null, _toDisplayString(nullMsg.price), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _withDirectives(_createElementVNode("input", {
            class: "w-11/12 h-10 pl-4 border border-solid border-[#D6D6D6] rounded-md text-sm font-normal placeholder:text-sm placeholder:text-zinc-300 placeholder:font-light focus:border-[#1B1B1D]",
            placeholder: "제목을 입력해주세요",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.title) = $event))
          }, null, 512), [
            [_vModelText, formData.title]
          ])
        ]),
        (nullMsg.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createTextVNode(),
              _createElementVNode("span", null, _toDisplayString(nullMsg.title), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _withDirectives(_createElementVNode("textarea", {
            class: "w-11/12 p-4 border border-solid border-[#D6D6D6] rounded-md resize-none text-sm font-normal placeholder:text-sm placeholder:text-zinc-300 placeholder:font-light focus:border-[#1B1B1D]",
            cols: "30",
            rows: "10",
            placeholder: "상세 내용을 입력해주세요",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.content) = $event))
          }, null, 512), [
            [_vModelText, formData.content]
          ])
        ]),
        (nullMsg.content)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _hoisted_37,
              _createTextVNode(),
              _createElementVNode("span", null, _toDisplayString(nullMsg.content), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("button", {
          class: "w-28 h-10 bg-pada text-white text-sm rounded-lg",
          onClick: submitData
        }, _toDisplayString(isEditMode.value ? '수정완료' : '등록'), 1)
      ]),
      _hoisted_39
    ]),
    (apiError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createVNode(ConfirmModal, {
            content1: "오류가 발생하였습니다.\n잠시 후 다시 이용해주세요",
            closeButton: "닫기",
            onUpdateClose: handleApiError
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})